module.exports = __webpack_public_path__ + "media/applications/components/ItemApp/assets/images/view-ee4f34fd074274270e5dc1c23a0185c8.svg";